module.exports = __webpack_public_path__ + "static/amazon-pay-15fdf8fa4e05b459dda9a686af799b9b.jpg";